<template>
<div class='slide slide--profile'>
  <div class='slide-profile_image'>
    <div
      class='slide-profile_image-img'
      :style='profileImage'
    />
  </div>

  <div class='slide_label body-four-light'>
    {{ activity.subheadline }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div class='slide_subheadline body-one-light'>
    {{ activity.content }}
  </div>
</div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  computed: {
    profileImage() {
      if (this.activity.profile_image) {
        return `background-image: url(${this.activity.profile_image})`
      }
      return null
    }
  }
}
</script>

<style lang='sass' scoped>
.slide-profile_image
  z-index: 2
  width: calc(100vh / 3.2) // 250px
  height: calc(100vh / 3.2) // 250px
  margin: 0 auto 2em

  @media (max-width: 768px)
    width: calc(100vh / 4.3)
    height: calc(100vh / 4.3)
    margin-bottom: 1.25em

.slide-profile_image-img
  border-radius: 50%
  background-repeat: no-repeat
  background-position: center center
  background-size: cover
  width: 100%
  height: 100%
</style>
